import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import * as moment from 'moment';
import 'moment-timezone';

/** Component for setting filters on the plot data */
@Component({
    selector: 'sci-range-selector-dialog',
    templateUrl: './range-selector-dialog.component.html',
    styleUrls: [ './range-selector-dialog.component.scss' ]
})
export class RangeSelectorDialogComponent {
    format = 'YYYY-DDD';
    timezone = 'utc';
    start: FormControl;
    end: FormControl;
    isDate = true;

    constructor( public dialogRef: MatDialogRef<RangeSelectorDialogComponent>, @Inject( MAT_DIALOG_DATA ) public data ) {
        this.start = new FormControl( moment.utc( data.start ) );
        this.end = new FormControl( moment.utc( data.end ) );
    }

    updateRange() {
        let s: moment.Moment = this.start.value;
        let e: moment.Moment = this.end.value;
        const isDate = this.isDate;

        if ( this.timezone === 'local' ) {
            s = this.convertFromLocal( s );
            e = this.convertFromLocal( e );
        }

        this.dialogRef.close({
            start: s.valueOf(),
            end: e.valueOf(),
            isDate: isDate
        });
    }

    convertFromLocal( local: moment.Moment ) {
        return local.subtract( local.local().utcOffset(), 'minutes' );
    }
}
